/* eslint-disable no-unused-vars */
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useSearchParams } from "react-router-dom";
import logo from "assets/logo.png";
import { verifyEmail } from "api/enterprise";

const OrganisationConfirmation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id") || "";

  const { isLoading, data, error, refetch } = useQuery({
    queryKey: ["email"],
    queryFn: () => verifyEmail(id),
    // suspense: true,
  });

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error || data?.status !== "success") {
    return (
      <FailedVerificationScreen message={data?.message} refetch={refetch} />
    );
  }

  return (
    <SuccessScreen
      message={data?.data?.enterprise?.fullName}
      organisationName={data?.data?.enterprise?.organisation_Name}
    />
  );
};

const LoadingScreen = () => (
  <div className="flex flex-col items-center justify-center">
    <div className="flex items-center justify-center mb-40">
      <img src={logo} className="w-[400px]" alt="ClassCube Enterprise" />
    </div>
    <span className="loader"></span>
  </div>
);

const FailedVerificationScreen = ({ message, refetch }) => (
  <div className="flex flex-col items-center justify-center">
    <div className="confirmation-screen text-5xl flex flex-col items-center justify-center">
      <div className="flex items-center justify-center mb-32">
        <img src={logo} className="w-[200px]" alt="ClassCube Enterprise" />
      </div>
      <h1 className="mb-3 text-5xl/15 text-center text-[#0372CE] text-wrap capitalize">
        {message}
      </h1>
      <p className="text-3xl">Please restart the verification process</p>
      <button
        type="submit"
        className="btn w-[80%] bg-[#0372CE] text-white p-[15px] text-[1.4rem] mt-[40px]"
        onClick={() => {
          refetch();
        }}
      >
        Restart
      </button>
    </div>
  </div>
);

const SuccessScreen = ({ organisationName, message }) => (
  <div className="flex flex-col items-center justify-center">
    <div className="confirmation-screen text-5xl flex flex-col items-center justify-center">
      <div className="flex items-center justify-center mb-20">
        <img src={logo} className="w-[200px]" alt="ClassCube Enterprise" />
      </div>
      <h1 className="mb-10 text-5xl/15 text-center text-[#2a3037] text-wrap capitalize">
        {" "}
        <span className="decoration-4">Hello </span>
        {message}, <br />{" "}
        <span className="py-7 lowercase text-4xl">
          your email has been verified
        </span>
      </h1>
      {/* <p className="text-3xl ">Please login to proceed</p> */}
      <button
        type="submit"
        className="btn w-[80%] bg-[#0372CE] text-white p-[15px] text-[1.4rem] mt-[40px] rounded-lg"
        onClick={() => {
          window.location.replace(
            `${process.env.REACT_APP_LOCAL_ADMIN_URL}/creator/${organisationName}`
          );
        }}
      >
        Please proceed to Login
      </button>
    </div>
  </div>
);

export default OrganisationConfirmation;
